import { Chip, Stack, Text } from '@/design';
import type { PointCloudColorMode as PointCloudColorModeValue } from '@/state/useViewerStore';

interface PointCloudColorModeProps {
  value: PointCloudColorModeValue;
  onChange(next: PointCloudColorModeValue): void;
}

interface ColorModeOption {
  id: PointCloudColorModeValue;
  label: string;
  icon: 'view_in_ar' | 'height' | 'tune' | 'category' | 'compare_arrows';
  shortcut: string;
}

const OPTIONS: ReadonlyArray<ColorModeOption> = [
  { id: 'rgb', label: 'RGB', icon: 'view_in_ar', shortcut: '1' },
  { id: 'elevation', label: 'Elevation', icon: 'height', shortcut: '2' },
  { id: 'intensity', label: 'Intensity', icon: 'tune', shortcut: '3' },
  { id: 'classification', label: 'Classification', icon: 'category', shortcut: '4' },
  { id: 'deviation', label: 'Deviation', icon: 'compare_arrows', shortcut: '5' },
] as const;

export function PointCloudColorMode({ value, onChange }: PointCloudColorModeProps) {
  return (
    <Stack direction="column" gap={1}>
      <Text variant="caption" as="span">
        Color mode
      </Text>
      <Stack direction="row" align="center" gap={1} style={{ flexWrap: 'wrap' }}>
        {OPTIONS.map((option) => (
          <Chip
            key={option.id}
            icon={option.icon}
            label={`${option.label} (${option.shortcut})`}
            variant={value === option.id ? 'info' : 'neutral'}
            pressable
            pressed={value === option.id}
            onClick={() => onChange(option.id)}
            aria-label={`Point cloud color mode ${option.label}`}
          />
        ))}
      </Stack>
    </Stack>
  );
}
